var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"value-field",style:({ opacity: _vm.Hide ? 0 : 1 })},[_c('div',{staticClass:"icon",class:_vm.IconClass}),_c('div',{staticClass:"property-name",domProps:{"innerHTML":_vm._s(_vm.T(_vm.TKey))}}),_c('div',{staticClass:"property-value"},[_vm._v("$"+_vm._s(_vm.ValueText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }